import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={movie.coverImage}
          alt={movie.title}
          title={`${movie.title} - 高清电影免费看 | 6080影院`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>

        <div className="absolute top-2 left-2 flex gap-1.5 flex-wrap">
          {movie.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded">
              热播
            </span>
          )}
          {movie.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-950 rounded">
              新上线
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-bold bg-background-950/70 text-accent-500 rounded">
            {movie.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-foreground-950 truncate">
            {movie.title}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-400">{movie.year}</span>
            <span className="text-xs text-foreground-500">·</span>
            <span className="text-xs text-foreground-400">{movie.category}</span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-white text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}